export const announcementsHeaderStaticProps = {
  title: 'Course Offer Announcements',
  buttonLabel: 'Add',
};

export const COURSE_LIMIT = 1000;

export const searchSelectProps = {
  showSearch: true,
  optionFilterProp: 'children',
  filterOption: (input, option) => {
    let filterStatus = false;

    if (!option.children) return false;

    if (typeof option.children === 'number') {
      const string = option.children?.toString?.();
      filterStatus = string.indexOf(input.toString()) >= 0;
    } else {
      filterStatus =
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }

    return filterStatus;
  },
};

export const selectInputParams = [
  {
    label: 'Lead Trainer',
    name: 'selectedLeadTrainer',
  },
  {
    label: 'Assistant Trainer',
    name: 'selectedAssistantTrainer',
  },
  {
    label: 'Support Staff',
    name: 'selectedSupport',
    mode: 'multiple',
  },
];

export const trainerRoles = {
  LEAD_TRAINER: 'leadTrainer',
  ASSISTANT_TRAINER: 'assistantTrainer',
  SUPPORT_TRAINERS: 'supportTrainers',
};
